export default __webpack_public_path__ + "feada6b9210e8539b897837e4385ca15.png";